import { useDispatch, useSelector } from 'react-redux';

import LazyImage from '../../ShowMedia/LazyImage';
import PreviewMediaDialog from '../../ShowMedia/PreviewMediaDialog';

import { useGalleryContext } from '../../../Contexts/GalleryContext';
import { setDialog } from '../../../../redux/Slices/Global/globalSlice';

/**
 * Tiny media thumbnail used inside CampaignCard rows.
 *
 * When `onPreview` is supplied, the click is forwarded to the parent
 * (CampaignContentSetup owns a useState slot and renders the dialog
 * at the page root, outside the dnd context). When it isn't, we keep
 * the legacy Redux/context wiring so other call sites still work.
 */
function MediaThumb({ item, onPreview }) {
    const dispatch = useDispatch();
    const { selectedItem, setSelectedItem } = useGalleryContext();
    const openDialog = useSelector((s) => s.global.openDialog);

    const open = (e) => {
        e?.stopPropagation();
        e?.preventDefault();
        if (onPreview) {
            onPreview(item);
            return;
        }
        setSelectedItem(item.id);
        dispatch(setDialog({ key: 'previewMedia', value: true }));
    };

    return (
        <>
            <button
                type="button"
                onClick={open}
                aria-label={`Preview ${item.file_name || ''}`}
                title="Preview"
                className="pp-cb-thumb-btn h-[58px] w-full flex justify-center items-center overflow-hidden bg-transparent border-0 p-0 cursor-pointer"
            >
                <LazyImage
                    media={item}
                    popupType="media_preview"
                    mountPreview={false}
                    index={item.id}
                    styleClass="me-2 image_container max-w-full max-h-full w-auto h-auto object-contain pointer-events-none"
                />
            </button>
            {!onPreview && selectedItem === item.id && openDialog?.previewMedia && (
                <PreviewMediaDialog data={item} />
            )}
        </>
    );
}

export default MediaThumb;
